{
    "ChannelCode": "Code",
    "Components": {
        "MeetingEnd": {
            "FeedbackConfirmation": {
                "ExploreMoreFeatures": "Explorer plus de fonctionnalités",
                "ThanksMessage": "Merci d'avoir participé,",
                "WorkingMessage": "nous espérons que la traduction a amélioré l'événement pour vous."
            },
            "FeedbackForm": {
                "FeedbackQuestion": "Comment était la qualité de la traduction ?",
                "SessionClosedMessage": "La traduction en direct est terminée.",
                "ThankYouMessage": "Nous espérons que cela vous a aidé !"
            }
        }
    },
    "Continue": "Continuer",
    "Control": {
        "Original": "Original",
        "Spacing": "Espacement",
        "TextSize": "Taille du texte",
        "Tts": "TTS"
    },
    "Download": "Télécharger",
    "Idle": "Inactif",
    "Join": "Rejoindre",
    "LanguageSettings": "Langue",
    "Live": "En cours",
    "Loading": {
        "Entering": "Entrée dans le canal",
        "Joining": "Connexion au canal"
    },
    "OK": "OK",
    "Pages": {
        "Home": {
            "EnterEventCodeMessage": "Veuillez saisir le code du canal.",
            "InputPlaceholder": "Saisir le code du canal",
            "Title": "Soyez présent. Comprenez tout."
        },
        "SelectLanguage": {
            "SearchEmpty": "Aucune langue correspondante",
            "SearchPlaceholder": "Rechercher une langue",
            "Title": "Choisissez votre langue de traduction"
        }
    },
    "Pane": {
        "CatchUp": "Aller au plus récent",
        "Source": "Original",
        "Translation": "Traduction",
        "Tts": "Synthèse vocale",
        "TtsShort": "TTS"
    },
    "Share": "Partager",
    "SpeechSpeed": "Vitesse de la parole",
    "Start": "Démarrer",
    "Submit": "Soumettre",
    "Tips": {
        "Error": {
            "Channel": {
                "LimitExceeded": "Ce canal a atteint sa limite de connexions."
            }
        },
        "Icon": {
            "ScrollToBottom": "Retour au plus récent",
            "ShareLink": "Partager le lien",
            "SpeechRate": "Régler la vitesse de lecture"
        }
    },
    "Toast": {
        "LanguageChanged": "Langue de traduction : {lang}",
        "LinkCopied": "Lien copié",
        "SourceOff": "Original masqué",
        "SourceOn": "Original affiché",
        "TtsOff": "Voix désactivée",
        "TtsOn": "Voix activée"
    },
    "Transcript": {
        "Start": "Début de la transcription"
    },
    "tutorialPage": {
        "downloadOverlay": {
            "originText": "Texte Original",
            "summary": "Résumé",
            "transcript": "Transcriptions"
        },
        "translationLanguage": {
            "title": "Langue de traduction"
        }
    }
}
